interface GlowingDotProps {
  className?: string
  size?: 'sm' | 'md'
  color?: 'yellow' | 'blue' | 'green' | 'red' | 'orange' | 'default'
  pulse?: boolean
}

const sizeClasses = {
  sm: 'w-1 h-1',
  md: 'size-1',
}

const shadowClasses: Record<
  NonNullable<GlowingDotProps['color']>,
  { sm: string; md: string }
> = {
  yellow: {
    sm: 'shadow-[0_0_4px_1px_rgba(250,204,21,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(250,204,21,0.8)]',
  },
  blue: {
    sm: 'shadow-[0_0_4px_1px_rgba(96,165,250,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(96,165,250,0.8)]',
  },
  green: {
    sm: 'shadow-[0_0_4px_1px_rgba(74,222,128,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(74,222,128,0.8)]',
  },
  red: {
    sm: 'shadow-[0_0_4px_1px_rgba(248,113,113,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(248,113,113,0.8)]',
  },
  orange: {
    sm: 'shadow-[0_0_4px_1px_rgba(251,146,60,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(251,146,60,0.8)]',
  },
  default: {
    sm: 'shadow-[0_0_4px_1px_rgba(156,163,175,0.8)]',
    md: 'shadow-[0_0_8px_2px_rgba(156,163,175,0.8)]',
  },
}

const getShadowClass = (size: 'sm' | 'md', color: GlowingDotProps['color']) => {
  return shadowClasses[color ?? 'default'][size]
}

const colorClasses = {
  yellow: 'bg-yellow-500',
  blue: 'bg-blue-500',
  green: 'bg-green-600',
  red: 'bg-red-600',
  orange: 'bg-orange-500',
  default: 'bg-gray-400',
}

export function GlowingDot({
  className = '',
  size = 'sm',
  color = 'default',
  pulse = false,
}: GlowingDotProps) {
  return (
    <div
      className={`${sizeClasses[size]} ${colorClasses[color]} rounded-full ${getShadowClass(size, color)} ${pulse ? 'animate-pulse' : ''} ${className}`}
    />
  )
}
